// src/utils/permissions.ts
export type UserLike = unknown;

export const extractPermissions = (user: any): string[] => {
  if (!user) return [];
  // common shapes
  if (Array.isArray(user.permissions)) return user.permissions;
  if (Array.isArray(user?.data?.permissions)) return user.data.permissions;
  // add more fallbacks if your state nests differently
  return [];
};

export const hasPermission = (user: UserLike, perm: string): boolean => {
  const perms = extractPermissions(user);
  return perms.includes(perm);
};
